import React from 'react'
import { useHistory } from 'react-router-dom'
import { ADMIN_ROUTES } from '../../../../constants'
import SydActionMenu from '../../../commonDesign/SydActionMenu'
import { useCheckPolicy } from '../../../../hooks'

export const BatchCreateAction = () => {
  const userCanCreateUsers = useCheckPolicy('admin_edit_users_bulkcreate')
  const userCanInviteUsers = useCheckPolicy('admin_edit_users_bulkinvite')

  const history = useHistory()

  const actions = [
    {
      icon: 'usersAdmin',
      label: 'Bulk Create Users',
      onClick: () => history.push(`${ADMIN_ROUTES.USER_BATCHES}/batch/new/?batchType=bulk-create-users`),
      visible: userCanCreateUsers
    },
    {
      icon: 'mail',
      label: 'Bulk Invite Users',
      onClick: () => history.push(`${ADMIN_ROUTES.USER_BATCHES}/batch/new/?batchType=bulk-invite-users`),
      visible: userCanInviteUsers
    }
  ]

  return (
    <SydActionMenu
      icon='add' actions={actions.filter(action => action.visible)}
    />
  )
}
